<template>
  <div v-if="isArchived" class="unit-card__alert-bottom prereq">
    <span class="unit-card__alert-bottom-content" :id="`tooltip-prereq-alert-${code}`">
      This unit has been discontinued <i class="far fa-exclamation-triangle"></i>
    </span>

    <b-tooltip :target="`tooltip-prereq-alert-${code}`" triggers="hover" placement="right" noninteractive>
      This unit has been discontinued and is no longer available.
    </b-tooltip>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import SlideOutUnitDetailsView from './slide-out-tree-view/SlideOutUnitDetailsView.vue'
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      slideOutComponent: SlideOutUnitDetailsView,
      slideOutComponentProperties: {
        relationship: this.item.relationship,
        location: this.item.location,
        firstLevelTitle: this.item.firstLevelTitle
      }
    }
  },
  methods: {
  },
  computed: {
    code() {
      return this.item.code
    },
    isDiscontinued() {
      // console.log('isDiscontinued', this.unit)
      return this.item.relationship?.masterStatus == 'Discontinued'
    },
    isArchived() {
      // console.log('isArchived', this.unit)
      return this.item.relationship?.masterStatus == 'Archived'
    }
  }
}
</script>
